import NotFound from './pages/fallbacks/NotFound'
import { routes as dashboard } from './pages/dashboard'
import { routes as loans } from './pages/loans'
import { routes as orders } from './pages/orders'
import { routes as users } from './pages/users'
import { routes as appraisers } from './pages/appraisers'
import { routes as profile } from './pages/profile'
import { routes as auth } from './pages/auth'
import { routes as branches } from './pages/branches'
import { routes as fee } from './pages/fee'
import { routes as activate } from './pages/activate'
import { routes as adminSettings } from './pages/adminSettings'
import { routes as review } from './pages/reviewRules'
import { routes as accounting } from './pages/accounting'
import { routes as allNotifications } from './pages/notifications'
import { routes as permissions } from './pages/permissions'
import { routes as reviewSettings } from './pages/reviewSettings'
import { routes as feeManagement } from './pages/feeManagement'
import { routes as notificationSettings } from './pages/notification-settings'
import { routes as needsAction } from './pages/needsAction'

import EmptyCenteredFlexLayout from './common/layout/EmptyCenteredFlexLayout'
import BasicLayoutContainer from './common/layout/BasicLayoutContainer'
import SidebarOnlyLayoutContainer from './common/layout/SidebarOnlyLayoutContainer'
import { loadableWithRetry } from './common/utils/lazyLoad'

const appRoutes = [
  {
    path: '/',
    exact: true,
    name: 'root',
    publicRoute: true,
    redirectTo: '/dashboard',
  },
  {
    path: '/dashboard',
    layout: BasicLayoutContainer,
    routes: dashboard,
    accessRedirectTo: '/auth/login',
  },
  {
    path: '/loan-files',
    layout: BasicLayoutContainer,
    routes: loans,
    accessRedirectTo: '/auth/login',
  },
  {
    path: '/needs-action',
    layout: BasicLayoutContainer,
    routes: needsAction,
    accessRedirectTo: '/auth/login',
  },
  {
    path: '/orders/:id/reviewer',
    layout: SidebarOnlyLayoutContainer,
    component: loadableWithRetry(() => import('./pages/reviewer')),
  },
  {
    path: '/orders',
    layout: BasicLayoutContainer,
    routes: orders,
    accessRedirectTo: '/auth/login',
  },
  {
    path: '/appraisers',
    layout: BasicLayoutContainer,
    routes: appraisers,
    accessRedirectTo: '/auth/login',
  },
  {
    path: '/users',
    layout: BasicLayoutContainer,
    routes: users,
    accessRedirectTo: '/auth/login',
  },
  {
    path: '/review',
    layout: BasicLayoutContainer,
    routes: review,
    accessRedirectTo: '/auth/login',
  },
  {
    path: '/branches',
    layout: BasicLayoutContainer,
    routes: branches,
    accessRedirectTo: '/auth/login',
  },
  {
    path: '/profile',
    layout: BasicLayoutContainer,
    routes: profile,
    accessRedirectTo: '/auth/login',
  },
  {
    path: '/fee',
    layout: BasicLayoutContainer,
    routes: fee,
    accessRedirectTo: '/auth/login',
  },
  {
    path: '/fee-management',
    layout: BasicLayoutContainer,
    routes: feeManagement,
    accessRedirectTo: '/auth/login',
    permission: 'fee_management_route',
  },
  {
    path: '/accounting',
    layout: BasicLayoutContainer,
    routes: accounting,
    accessRedirectTo: '/dashboard',
  },
  {
    path: '/admin_settings',
    layout: BasicLayoutContainer,
    routes: adminSettings,
    accessRedirectTo: '/auth/login',
  },
  {
    path: '/review-settings',
    layout: BasicLayoutContainer,
    routes: reviewSettings,
    accessRedirectTo: '/auth/login',
  },
  {
    path: '/activate',
    layout: EmptyCenteredFlexLayout,
    routes: activate,
    publicRoute: true,
  },
  {
    path: '/auth',
    routes: auth,
    publicRoute: true,
  },
  {
    path: '/notifications',
    layout: BasicLayoutContainer,
    routes: allNotifications,
    accessRedirectTo: '/dashboard',
  },
  {
    // Distinct from `/notifications` (the notifications inbox). The container
    // gates on the `role_notification_settings_override` permission.
    path: '/notification-settings',
    layout: BasicLayoutContainer,
    routes: notificationSettings,
    accessRedirectTo: '/dashboard',
  },
  {
    path: '/permissions',
    layout: BasicLayoutContainer,
    routes: permissions,
    accessRedirectTo: '/dashboard',
  },
  {
    component: NotFound,
  },
]

export default appRoutes
export const namedRoutes = routesMap(appRoutes)

function routesMap(routes, basePath = '/') {
  return routes.reduce(function(acc, { name, path, routes }) {
    if (!path) {
      return acc
    }

    path = makePath(path, basePath)

    if (name) {
      acc = {
        ...acc,
        [name]: path,
      }
    }

    if (routes) {
      acc = {
        ...acc,
        ...routesMap(routes, path),
      }
    }
    return acc
  }, {})
}

function makePath(path, basePath) {
  return (basePath + path).replace(/\/+/g, '/')
}
